import React, { FC } from 'react'
import styled from '~/app/components/styled'
import yaLogo from '~/app/imgs/empty-thumnail-yanolja-h-56.svg?inline'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { useBusTransportationCompanyQuery } from '~/__generated__/app/query/order-details/BusTransportationCompany.graphql'
import { getBusImage } from '~/app/components/order-converter/converter/BusOrderConverter'
import { Typography } from '@yanolja-rnd/ya-com-core'

interface BusImageProps {
  transportationCompanyCode?: string
}

const Image = styled(LazyLoadImage)`
  position: relative;
  width: 5.6rem;
  height: 5.6rem;
  border-radius: 0.4rem;
`

const DefaultBusLogo = styled.div`
  width: 100%;
  ${Typography('body2').regular};
  color: ${({ theme: { color } }) => color.gray900};
`

const BusImage: FC<BusImageProps> = ({ transportationCompanyCode }) => {
  const imageSrc = getBusImage(transportationCompanyCode, false)

  const { data } = useBusTransportationCompanyQuery({
    variables: { code: transportationCompanyCode! },
    fetchPolicy: 'cache-first',
    skip: !transportationCompanyCode || !!imageSrc,
  })

  if (imageSrc) {
    return (
      <div className="image">
        <Image alt={'상품 사진'} src={imageSrc} placeholderSrc={yaLogo} />
      </div>
    )
  }

  if (transportationCompanyCode) {
    const companyName = data?.busTransportationCompany?.name
    if (companyName) {
      return (
        <div className="image">
          <DefaultBusLogo>{companyName}</DefaultBusLogo>
        </div>
      )
    }
  }
  return (
    <div className="image">
      <Image alt={'상품 사진'} placeholderSrc={yaLogo} />
    </div>
  )
}

export default BusImage
